var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "leo-operator-assistant-host" },
        [
          _c(
            "button",
            {
              staticClass: "leo-operator-assistant-fab",
              attrs: { type: "button", title: "Leo SOC助手" },
              on: { click: _vm.openAssistant }
            },
            [_vm._v("\n    Leo SOC助手\n  ")]
          ),
          _vm._v(" "),
          _c("leo-training-operator-assistant")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-000199f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000199f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoTrainingOperatorAssistantHost.vue
// module id = null
// module chunks = 